import { render, staticRenderFns } from "./NpsConsultant.vue?vue&type=template&id=8a3f35ce&scoped=true"
import script from "./NpsConsultant.vue?vue&type=script&lang=js"
export * from "./NpsConsultant.vue?vue&type=script&lang=js"
import style0 from "./NpsConsultant.vue?vue&type=style&index=0&id=8a3f35ce&prod&lang=scss&scoped=true"
import style1 from "./NpsConsultant.vue?vue&type=style&index=1&id=8a3f35ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3f35ce",
  null
  
)

export default component.exports